import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { LoadingService } from '../../services/loading.service';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';

@Component({
  selector: 'seech-http-progress-indicator',
  standalone: true,
  imports: [CommonModule, ProgressBarComponent],
  template: `
    <div *ngIf="isLoading" class="http-progress-indicator">
      <seech-progress-bar 
        [isIndeterminate]="true"
        [height]="'4px'"
        [color]="'primary'"
        [borderRadius]="'0px'">
      </seech-progress-bar>
    </div>
  `,
  styles: [`
    .http-progress-indicator {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 9999;
      width: 100%;
    }
  `]
})
export class HttpProgressIndicatorComponent implements OnInit, OnDestroy {
  isLoading = false;
  private subscription?: Subscription;

  constructor(private loadingService: LoadingService) {}

  ngOnInit(): void {
    this.subscription = this.loadingService.isLoading.subscribe(
      (loading) => {
        this.isLoading = loading;
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
